<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="!isNewCostCenterNumber">
                        Edycja MPK
                    </template>
                    <template v-else>
                        Nowy MPK
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-text-field
                    v-model="costCenterNumber.number"
                    label="Kod"
                    outlined
                    dense
                    :error-messages="costCenterNumberCodeErrors"
                />
                <v-textarea
                    v-model="costCenterNumber.description"
                    label="Opis"
                    outlined
                    dense
                    auto-grow
                    hide-details
                />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { isEmpty } from 'lodash'
import { required, minValue, integer } from 'vuelidate/lib/validators'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'CostCenterNumberDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        costCenterNumberData: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            costCenterNumber: {
                number: null,
                description: null
            },
            actionLoading: false
        }
    },
    validations() {
        return {
            costCenterNumber: {
                number: {
                    integer,
                    required,
                    minValue: minValue(1)
                },
            },
        }
    },
    computed: {
        isNewCostCenterNumber() {
            return isEmpty(this.costCenterNumberData)
        },
        // Walidacje
        costCenterNumberCodeErrors() {
            const errors = []

            if (!this.$v.costCenterNumber.number.$dirty) return errors

            if (!this.$v.costCenterNumber.number.required || !this.$v.costCenterNumber.number.minValue) {
                errors.push('Proszę podać kod MPK.')
            }

            return errors
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean && this.costCenterNumberData) {
                this.costCenterNumber = JSON.parse(JSON.stringify(this.costCenterNumberData))
            } else {
                setTimeout(() => {
                    this.$v.$reset()
                    this.costCenterNumber = {
                        number: null,
                        description: null
                    }
                }, 500)
            }
        }
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }
            let payload = JSON.parse(JSON.stringify(this.costCenterNumber))

            let action = null

            if (this.isNewCostCenterNumber) {
                action = 'createCostCenterNumber'
            } else {
                action = 'updateCostCenterNumber'
            }

            this.actionLoading = true
            this.$store.dispatch(`administration/${action}`, payload)
                .then(() => {
                    this.$emit('on-save')
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                    this.onClose()
                })
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>